import React, { useState, useEffect } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';


import { setUser } from "../utils/auth"
import APIS from "../utils/APIS"

const SignUp = () => {
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState()

  return (
    <>
      <Helmet>
        <title>Inscription Recruteur | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              firstName: '',
              name : '',
              email: '',
              companyName : '',
            }}
            validationSchema={Yup.object().shape({
              firstName: Yup.string().min(2, "Votre prénom est requis").max(255).required('Votre prénom est requis'),
              name: Yup.string().min(2, "Votre nom est requis").max(255).required('Votre nom est requis'),
              email: Yup.string().email("Veuillez renseigner votre email").max(255).required('Veuillez renseigner votre email'),
              companyName: Yup.string().min(2, "Le nom de l'entreprise est requis").max(255).required("Le nom de l'entreprise est requis"),
            })}
            onSubmit={(values, { setSubmitting }) => {
              setAlertMessage("");
              const user = { email: values.email, firstName : values.firstName, name: values.name, companyName: values.companyName }
              APIS.registerRecruiter(user).then(result => {
                if (result?.message === "registerRecruiter") {
                  let uuidValidate = "dbff0d04-628a-47ce-960e-4a216b3ff3f0"
                  navigate("/validateCode?noValid="+uuidValidate+"&email="+values?.email+"&i="+result?.id)
                } if (result?.message === "emailExist") {
                  setAlertMessage("Email déjà utilisée");
                  setSubmitting(false);
                } else {
                  setAlertMessage("Erreur inconue");
                  setSubmitting(false);
                }
              })

            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 2, textAlign:"center" }}>
                  <Typography
                    color="textBlack"
                    variant="h2"
                  >
                    Inscription recruteur
                  </Typography>
                </Box>
                <Box sx={{display:"flex", gap:"15px"}}>
                  <TextField
                    error={Boolean(touched.firstName && errors.firstName)}
                    fullWidth
                    helperText={touched.firstName && errors.firstName}
                    label="Prénom"
                    margin="normal"
                    name="firstName"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.firstName}
                    variant="outlined"
                  />
                  <TextField
                    error={Boolean(touched.name && errors.name)}
                    fullWidth
                    helperText={touched.name && errors.name}
                    label="Nom"
                    margin="normal"
                    name="name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.name}
                    variant="outlined"
                  />
                </Box>
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Adresse Email"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.companyName && errors.companyName)}
                  fullWidth
                  helperText={touched.companyName && errors.companyName}
                  label="Nom de l'entreprise"
                  margin="normal"
                  name="companyName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.companyName}
                  variant="outlined"
                />
                <Box sx={{ py: 2 }}>
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    endIcon={<ChevronRightIcon/>}
                  >
                    Suivant
                  </Button>
                </Box>
                <Box sx={{
                  marginTop:"15px",
                  marginBottom:"15px",
                  fontSize:"16px",
                  textAlign:"center",
                  color : "text.primary",
                }}>
                  Déjà un compte ?
                  <Link component={RouterLink} to="/login" sx={{marginLeft:"3px"}}>
                    Connectez-vous
                  </Link>
                </Box>
                {alertMessage && alertMessage.length > 0 && (
                  <Box
                    sx={{
                      pb: 1,
                      pt: 1,
                    }}
                  >
                    <Typography
                      align="center"
                      color="red"
                      variant="body1"
                    >
                      {alertMessage}
                    </Typography>
                  </Box>
                )}
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </>
  );
};

export default SignUp;
